import CustomerLogoWrapper from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogoWrapper';
import {CustomerLogoRenderProps} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogo';

export const CustomerLogoOpenAI = ({
  colorWay,
  contextId,
  ...props
}: Omit<CustomerLogoRenderProps, 'logoViewboxAlignments' | 'title'>) => {
  return (
    <CustomerLogoWrapper
      xmlns="http://www.w3.org/2000/svg"
      logoViewboxAlignments={{
        left: 51.658,
        right: -51.65799999999999,
        top: 6.71,
        bottom: -7.287999999999997,
      }}
      title="OpenAI"
      {...props}
    >
      <path
        fill="var(--userLogoColor, #000)"
        d="M61.944 6.71c-5.658 0-10.286 4.63-10.286 10.287 0 5.657 4.628 10.286 10.285 10.286 5.658 0 10.286-4.6 10.286-10.286A10.28 10.28 0 0061.943 6.71zm0 16.887c-3.515 0-6.344-2.886-6.344-6.6 0-3.715 2.83-6.6 6.343-6.6s6.343 2.885 6.343 6.6c0 3.714-2.828 6.6-6.343 6.6zm20.685-11.171c-1.857 0-3.657.743-4.6 2v-1.714h-3.714v20h3.714v-7.229c.943 1.171 2.686 1.8 4.6 1.8 4 0 7.143-3.143 7.143-7.429 0-4.285-3.143-7.428-7.143-7.428zM82 24.055c-2.114 0-4-1.658-4-4.2s1.886-4.2 4-4.2 4 1.657 4 4.2c0 2.542-1.885 4.2-4 4.2zm16.515-11.63c-4.057 0-7.257 3.172-7.257 7.43 0 4.257 2.8 7.428 7.371 7.428 3.743 0 6.143-2.257 6.886-4.8h-3.628c-.458 1.057-1.743 1.8-3.286 1.8-1.915 0-3.372-1.343-3.715-3.257h10.8v-1.457c0-3.886-2.714-7.143-7.171-7.143zm-3.6 5.972c.4-1.8 1.886-2.971 3.686-2.971 1.914 0 3.371 1.257 3.543 2.971h-7.23zm20.658-5.971c-1.658 0-3.4.743-4.2 1.971v-1.685h-3.715v14.285h3.715v-7.685c0-2.23 1.2-3.686 3.142-3.686 1.8 0 2.772 1.371 2.772 3.286v8.085h3.714v-8.685c0-3.543-2.172-5.886-5.428-5.886zm14.941-5.428l-8.086 20h3.972l1.714-4.371h9.2l1.714 4.371h4.029l-8.029-20h-4.514zM129.4 19.313l3.314-8.372 3.285 8.371H129.4zm18.942-12.315h-3.771v20h3.771v-20z"
      />
    </CustomerLogoWrapper>
  );
};
